<template>
  <div class="music-container">
    <div class="banner">
      <div class="banner-crumb-sr-only">
        <vf-breadcrumb :data="breadData" type="banner"></vf-breadcrumb>
      </div>
      <div class="banner-center">
        <div class="banner-search-row">
          <div class="banner-search-block">
            <Search
              class="search-input"
              mode="label_page"
              placeholder="输入音乐/标签名称，找音乐"
              @search="handleSearch"
            />
            <div class="hot-tag-box">
              <span class="hot-tag-label">热搜词:</span>
              <Tag
                class="hot-tag-box-item"
                v-for="(item, index) in hotSearch"
                :key="index"
                mode="text"
                @onTag="handleHotTagClick(item)"
              >&nbsp;&nbsp;{{ item.name }}&nbsp;&nbsp;</Tag>
            </div>
          </div>
          <button v-show="false" type="button" class="banner-action-btn">
            <svg class="banner-action-icon" viewBox="0 0 18 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path
                fill="none"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M1 8h1.2l1.2-4.5 1.6 9 1.6-9.5 1.6 8 1.6-6.5 1.6 5.5 1.6-3.5L14.2 8H17"
              />
            </svg>
            <span>AI识曲</span>
          </button>
          <button type="button" class="banner-action-btn" @click="handleOpenService">
            <i class="el-icon-service"></i>
            <span>人工选曲</span>
          </button>
        </div>
      </div>
    </div>
    <div class="content-layout">
      <TagsFilte ref="tagsRef" :pager="pageQuery" @getList="UpdateList" @pageChange="getList"></TagsFilte>
      <div class="main-panel">
        <music-list :listLoading="listLoading" :list="list"></music-list>
        <div class="vf-music-pagination" v-if="JSON.stringify(pageQuery) !== '{}'">
          <Pagination v-if="pageQuery.total > 0" :hiddenPage="true" position="center" :limit.sync="pageQuery.limit"
            :page.sync="pageQuery.page" @pagination="pagination" :total="pageQuery.total" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  fetchMusicHotSearch,
  fetchMusicList
} from '@/api/music'
import Search from '@/components/Search'
import Tag from '@/components/Tag'
import Buttons from '@/layout/mixins/Buttons'
import { mapGetters } from 'vuex'
import { send_eventApi } from '@/utils/common.js'
import MusicList from './components/MusicList.vue'
import TagsFilte from './components/TagsFilterNew.vue'
import Pagination from '@/components/Pagination'
import VfBreadcrumb from '@/components/VfBreadcrumb.vue'

export default {
  name: 'NewMusicList',
  components: { Search, Tag, MusicList, TagsFilte, Pagination, VfBreadcrumb },
  mixins: [Buttons],
  data() {
    return {
      breadData: [
        { breadcrumbName: 'PlayList素材网', path: '/' },
        { breadcrumbName: '音乐列表' }
      ],
      hotSearch: [],
      list: [],
      listLoading: false,
      pageQuery: {
        total: 0,
        page: 1,
        limit: 10
      },
      tagParams: {}
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    })
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'musiceDetail' || from.name == 'musiceDownDetail') {
      next()
    } else {
      next(vm => {
        vm.pageQuery.page = 1
        vm.$refs.tagsRef.cleanTagSearch()
        vm.tagParams = {}
        vm.getList()
      })
    }
  },
  created() {
    this.getHot()
    this.getList()
  },
  methods: {
    async getHot() {
      try {
        const params = {
          type: 2
        }
        const { data } = await fetchMusicHotSearch(params)
        this.hotSearch = data
      } catch (e) {
        console.log(e)
      }
    },
    UpdateList(params) {
      this.tagParams = params
      this.pageQuery.page = 1
      this.getList()
    },
    async getList() {
      this.listLoading = true
      try {
        const { data } = await fetchMusicList({
          ...this.tagParams,
          page: this.pageQuery.page,
          page_size: this.pageQuery.limit,
          more: 1
        })
        this.pageQuery.total = data.total
        this.list = data.list
        this.listLoading = false
      } catch (e) {
        console.log(e)
        this.listLoading = false
      }
    },
    handleHotTagClick(item) {
      const obj = {
        label_name: item.name,
        user_name: this.userInfo ? this.userInfo.name : '',
        user_id: this.userInfo ? this.userInfo.user_id : ''
      }
      send_eventApi('e_slt', obj)
      this.$router.push({
        path: '/search-result',
        query: {
          type: 2,
          keyword_name: item.name
        }
      })
    },
    handleOpenService() {
      window.qimoChatClick()
    },
    pagination(e) {
      this.pageQuery.page = e.page
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
      this.getList()
    },
    handlePageChange(v) {
      this.pageQuery.page = v
      this.$set(this.pageQuery, 'page', v)
    }
  }
}
</script>

<style lang="scss" scoped>
.vf-music-pagination {
  margin-top: 40px;
  /deep/.el-pagination {

    .btn-quicknext + .number  {
      // display: none;
      // display: block;
    }

}
}
.music-container {
  min-height: 100vh;
  min-width: 1000px;
  margin-bottom: 70px;
  background: #fff;

  .content-layout {
    display: grid;
    grid-template-columns: 200px 1fr;
    grid-template-rows: auto 1fr;
    column-gap: 0;
    width: 100%;
    max-width: none;
    padding: 0 40px 0;
    box-sizing: border-box;
    background: #fff;
    position: relative;
    z-index: 1;
  }

  .main-panel {
    grid-column: 2;
    grid-row: 2;
    min-width: 0;
    width: 100%;
    padding-left: 16px;
    padding-right: 10px;
    box-sizing: border-box;
  }

  .banner {
    width: 100%;
    height: 150px;
    margin-top: 60px;
    position: relative;
    margin-bottom: 0;
    z-index: 2;
    border-bottom: 1px solid #E8E8E8;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
    background: url('~@/assets/image/picture_bg.png') no-repeat center center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;

    .banner-crumb-sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }

    .banner-center {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 30px;
    }

    .banner-search-row {
      display: flex;
      align-items: flex-start;
      gap: 12px;
    }

    .banner-search-block {
      width: 786px;
      display: flex;
      flex-direction: column;
    }

    /deep/.search-container {
      @include size(786px, 56px);

      .input {
        border: none;
        background: rgba(255, 255, 255, 0.8);

        .input-text.dark_color .el-input__inner {
          &::-webkit-input-placeholder {
            color: rgba(0, 0, 0, 0.5);
          }

          &::-moz-placeholder {
            color: rgba(0, 0, 0, 0.5);
          }

          &:-ms-input-placeholder {
            color: rgba(0, 0, 0, 0.5);
          }
        }
      }

      .btn {
        font-size: 18px;
      }
    }

    .banner-action-btn {
      height: 56px;
      padding: 0 24px;
      border-radius: 28px;
      background: #fff;
      color: #F84949;
      border: none;
      font-size: 15px;
      font-weight: 600;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      flex-shrink: 0;
      cursor: pointer;
      transition: background 0.2s, color 0.2s;

      .banner-action-icon {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
      }

      &:hover {
        background: #F84949;
        color: #fff;
      }
    }

    .hot-tag-box {
      width: 100%;
      margin: 12px 0 0;
      text-align: left;
      line-height: 20px;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      margin-left: 15px;

      .hot-tag-label {
        flex-shrink: 0;
        margin-right: 4px;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
      }

      &-item {
        @include font-normal($size: 14px, $color: rgba(255, 255, 255, 0.8));
      }

      &-item:hover {
        color: $theme-color;
      }
    }
  }
}
</style>
